module.exports = __webpack_public_path__ + "static/media/fire-alt.10b0f750.svg";